import type { App } from 'vue';
import { BaseBreadcrumb, CommonEntryPoint, CommonNotFound } from '@/core/components/common';
import { LayoutAuth, LayoutCapture, LayoutDefault, LayoutEmpty } from '@/core/components/layouts';
import LayoutClean from '@/core/components/layouts/LayoutClean.vue';

/**
 * Global register component
 * @params app
 */
const RegisterCoreComponent = (app: App) => {
  app.component('BaseBreadcrumb', BaseBreadcrumb);
  // Layout
  app.component('LayoutCapture', LayoutCapture);
  app.component('LayoutEmpty', LayoutEmpty);
  app.component('LayoutAuth', LayoutAuth);
  app.component('LayoutDefault', LayoutDefault);
  app.component('LayoutClean', LayoutClean);

  // Common
  app.component('CommonNotFound', CommonNotFound);
  app.component('CommonEntryPoint', CommonEntryPoint);
};

export default RegisterCoreComponent;
